import { render, staticRenderFns } from "./organization-wallet-card.vue?vue&type=template&id=018d3004"
import script from "./organization-wallet-card.vue?vue&type=script&lang=js"
export * from "./organization-wallet-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports